import React, { useEffect, useState } from 'react'
import AppBar from '../components/app-bar'
import { Button, CircularProgress, MenuItem, Typography, makeStyles, LinearProgress, TableBody, TableCell, TableRow, TableContainer, Table, TableHead, Dialog, Menu } from '@material-ui/core'
import { customTheme } from '../styling'
import { Box } from '@mui/material'
import AddIcon from '@mui/icons-material/Add';
import GeneralError from '../components/error'
import moment from 'moment'
import deleteIcon from '../images/delete-icon.svg'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import condividiSvg from '../images/condividi.svg'
import DownloadIcon from '@mui/icons-material/Download'
import axiosInstance from '../axios'
import chatAssistantHome from '../images/burger-menu/chat-assistant-home.svg'
import chatMinHome from '../images/burger-menu/chat-mini-home.svg'
import translatorHome from '../images/burger-menu/ai-translator-home.svg'
import videoMakerHome from '../images/burger-menu/video-maker-home.svg'
import aiImagesHome from '../images/burger-menu/ai-images-home.svg'
import speechToSpeechHome from '../images/burger-menu/speech-to-speech-home.svg'
import liveTranslatorHome from '../images/burger-menu/live-translator-home.svg'
import { enqueueSnackbar } from 'notistack'
import { INTERNAL_SERVER_ERROR_MESSAGE } from '../constants'

const useStyles = makeStyles(theme => ({
  appBarSpacer: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(4),
    height: '100vh',
    overflow: 'auto',
  },
  title: {
    color: customTheme.colors.ui.blue
  },
  loadingContainer: {
    position: 'absolute',
    top: '50%',
    left: '55%'
  },
  gridBox1: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr',
    gap: '1rem',
  },

  featuresGrid: {
    marginTop: '1rem',
    display: 'grid',
    gridTemplateColumns: 'repeat(7, 1fr)',
    gap: 10,
    alignItems: 'stretch',
  },
  featureCard: {
    borderRadius: 15,
    padding: '1.5rem 0.4rem',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  featureActions: {
    marginTop: 'auto',           
    paddingTop: theme.spacing(2.5) 
  },
}))

const allChatbotFilterId = 46732567432854328856437563756483256836254356348

const Dashboard = () => {
  const urlParam = new URLSearchParams(location.search)
  const from = urlParam.get('from')
  const to = urlParam.get('to')
  const classes = useStyles()
  const history = useHistory()
  const [userDetails, setUserDetails] = useState(null)

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)

  const [totalArchiveOpen, setTotalArchiveOpen] = useState(false)
  const [archive, setArchive] = useState([])
  const [users, setUsers] = useState([])
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showmenu, setshowmenu] = useState(null)
  const openMenuUser = Boolean(anchorEl);
  const [loadingGrant, setLoadingGrant] = useState([])

  const handleClose = () => {
    setAnchorEl(null);
    setshowmenu(null)
  };

  const handleRemoveGrant = async (id, email, url) => {
    setLoadingGrant([...loadingGrant, email + url])
    try {
      const body = { email }
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${url}/${id}/revoke`, body)
      getAllData().then((res) => {
        const archiveResults = Object.values(res).flat().sort((a, b) => b.created_at.localeCompare(a.created_at))
        setArchive(archiveResults)
      }).catch((error) => {
        console.log(error)
      })
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }

  const handleAddGrant = async (id, email, url) => {
    setLoadingGrant([...loadingGrant, email + url])
    try {
      const body = { email }
      await axiosInstance.post(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${url}/${id}/grant`, body)
      await axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/${url}`)
      getAllData().then((res) => {
        const archiveResults = Object.values(res).flat().sort((a, b) => b.created_at.localeCompare(a.created_at))
        setArchive(archiveResults)
      }).catch((error) => {
        console.log(error)
      })
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
    } finally {
      setLoadingGrant(loadingGrant.filter((loadingGrantId) => loadingGrantId !== email))
    }
  }

  useEffect(() => {
    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/user`)
      .then((res) => {
        setUserDetails(res.data.payload)
      }).catch(() => {})

    getAllData().then((res) => {
      const archiveResults = Object.values(res).flat().sort((a, b) => b.created_at.localeCompare(a.created_at))
      setArchive(archiveResults)
    }).catch((error) => {
      console.log(error)
    })

    axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/users`)
      .then((res) => {
        setUsers(res.data.payload.users)
      }).catch(() => {})
  }, [])

  const getAllData = async () => {
    const [res1, res2, res3, res4] = await Promise.all([
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/text_to_speeches`),
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_speeches`),
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/speech_to_texts`),
      axiosInstance.get(`${process.env.REACT_APP_BACKOFFICE_API_DOMAIN}/api/v1/images`),
    ])

    return {
      textToSpeech: [...res1.data.payload.text_to_speeches.filter(({ writable }) => writable).map((file) => ({ ...file, url: 'text_to_speeches', type: 'Audio' }))],
      speechToSpeech: [...res2.data.payload.speech_to_speeches.filter(({ writable }) => writable).map((file) => ({ ...file, url: 'speech_to_speeches', type: 'Audio' }))],
      speechToText: [...res3.data.payload.speech_to_texts.filter(({ writable }) => writable).map((file) => ({ ...file, url: 'speech_to_texts', type: 'Audio' }))],
      images: [...res4.data.payload.images.filter(({ writable }) => writable).map((file) => ({ ...file, url: 'images', type: 'AI Image' }))],
    }
  }

  const handleDownload = async (filename, file_url, content_type) => {
    try {
      const response = await axiosInstance.get(file_url, { responseType: 'blob' })
      const blob = new Blob([response.data])
      const downloadUrl = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = downloadUrl
      link.download = content_type === 'image/jpg' ? filename + '.jpg' : filename
      link.click()
      URL.revokeObjectURL(downloadUrl)
    } catch (error) {
      enqueueSnackbar({ variant: 'error', message: INTERNAL_SERVER_ERROR_MESSAGE })
      console.log('error', error)
    }
  }

  return (
    <AppBar>
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />

        {error ? <GeneralError /> : loading ? (
          <Box className={classes.loadingContainer}>
            <CircularProgress />
          </Box>
        ) : (
          <Box style={{ width: '100%' }}>
            {totalArchiveOpen &&
              <Dialog onClose={() => setTotalArchiveOpen(false)} fullWidth maxWidth="lg" open={totalArchiveOpen}>
                <Box style={{ padding: '2rem' }}>
                  <Typography style={{ fontWeight: 'bold' }}>Archivio totale</Typography>
                  <TableContainer style={{ marginTop: '1rem' }}>
                    <Table aria-label="simple table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Nome del file</TableCell>
                          <TableCell>Tipo file</TableCell>
                          <TableCell>Data</TableCell>
                          <TableCell>Dettagli condivisione</TableCell>
                          <TableCell></TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {archive.length ? archive.map((file) => (
                          <TableRow
                            key={file.id}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                          >
                            <TableCell component="th" scope="row">
                              {file?.filename}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {file.type}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              {moment(file.created_at).format('DD MMM YYYY - hh:mm')}
                            </TableCell>
                            <TableCell component="th" scope="row">
                              <Box><Box style={{ display: 'flex', flexDirection: 'row' }}>
                                <Box style={{
                                  marginRight: '0.5rem',
                                  width: 22,
                                  height: 22,
                                  borderRadius: '50%',         
                                  display: 'inline-flex',       
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  background: userDetails?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39',
                                  color: 'white',
                                  lineHeight: 1,                
                                  textTransform: 'uppercase',  
                                  }}>{userDetails?.first_name.slice(0, 1)}
                                </Box>
                                {userDetails?.first_name} {userDetails?.last_name}
                              </Box></Box>
                            </TableCell>

                            <TableCell>
                              <img
                                onClick={(event) => {
                                  setshowmenu(file.id)
                                  setAnchorEl(event.currentTarget)
                                }}
                                src={condividiSvg}
                                style={{ marginRight: '0.5rem', cursor: 'pointer' }}
                              />
                              <DownloadIcon
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleDownload(file.filename, file.file_url, file.content_type)}
                              />
                            </TableCell>

                            {showmenu === file.id && (
                              <Menu
                                id="basic-menu"
                                anchorEl={anchorEl}
                                open={openMenuUser}
                                onClose={handleClose}
                                MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                              >
                                {users.map(({ id, first_name, last_name, email }) => {
                                  return (first_name || last_name) && (
                                    <MenuItem style={{ display: 'block' }} key={id}>
                                      <Box style={{
                                        float: 'left',
                                        marginRight: '0.5rem',
                                        borderRadius: 15, width: '24px', textAlign: 'center',
                                        height: '24px', background: email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39', color: 'white'
                                      }}>
                                        {first_name.slice(0, 1)}
                                      </Box>
                                      <Typography id="basic-menu" style={{ marginRight: '0.5rem', float: 'left' }}>
                                        {first_name} {last_name}
                                      </Typography>
                                      {loadingGrant.includes(email + file.url)
                                        ? <CircularProgress size={12} style={{ float: 'right' }} />
                                        : file?.grantees?.find((grant) => email === grant.email)
                                          ? <img src={deleteIcon} onClick={() => handleRemoveGrant(file.id, email, file.url)} style={{ cursor: 'pointer', color: customTheme.colors.ui.red, float: 'right' }} />
                                          : <AddIcon onClick={() => handleAddGrant(file.id, email, file.url)} style={{ cursor: 'pointer', color: customTheme.colors.ui.black, float: 'right' }} />
                                      }
                                    </MenuItem>
                                  )
                                })}
                              </Menu>
                            )}
                          </TableRow>
                        )) : null}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              </Dialog>
            }

            <Box className={classes.gridBox1}>
              <Box style={{ border: `1px solid ${customTheme.colors.ui.grey}`, padding: '1rem', borderRadius: 15}}>
                <Typography component="h1" variant="h6" color="inherit" noWrap style={{ fontWeight: 'bold' }}>
                  Dettagli budget
                </Typography>
                <LinearProgress
                  style={{ height: 50, borderRadius: 15, margin: '1rem 0' }}
                  value={(((userDetails?.quota_amount - userDetails?.quota_consumed) / userDetails?.quota_amount) * 100)}
                  variant="determinate"
                />
                <Typography component="h1" variant="h6" color="inherit" noWrap>
                  Hai ancora a disposizione il <span style={{ fontWeight: 'bold' }}>{Math.round(((userDetails?.quota_amount - userDetails?.quota_consumed) / userDetails?.quota_amount) * 100)}%</span> dei tuoi crediti totali
                </Typography>
              </Box>
            </Box>

            <Box style={{ display: 'grid', gridTemplateColumns: '1fr', marginTop: '1rem' }}>
              <Box style={{ border: `1px solid ${customTheme.colors.ui.grey}`, padding: '1rem', borderRadius: 15 }}>
                <Typography component="h1" variant="h6" color="inherit" noWrap style={{ fontWeight: 'bold' }}>
                  Funzionalità
                </Typography>

                <Box className={classes.featuresGrid}>
                  <Box className={classes.featureCard} style={{ opacity: !userDetails?.enable_chat && 0.5, border: `1px solid #ff7e85` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={chatAssistantHome} /> Chat Assistant
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={!userDetails?.enable_chat}
                        onClick={() => userDetails?.enable_chat && history.push('/chat')}
                        style={{ backgroundColor: '#ff7e85', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>

                  <Box className={classes.featureCard} style={{ opacity: !userDetails?.enable_chat_mini && 0.5, border: `1px solid #ff8800` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={chatMinHome} /> Chat Mini
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={!userDetails?.enable_chat_mini}
                        onClick={() => userDetails?.enable_chat_mini && history.push('/chat')}
                        style={{ backgroundColor: '#ff8800', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>

                  <Box className={classes.featureCard} style={{ opacity: !userDetails?.enable_translation && 0.5, border: `1px solid #ba5fff` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={translatorHome} /> AI Translator
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={!userDetails?.enable_translation}
                        onClick={() => userDetails?.enable_translation && history.push('/translator')}
                        style={{ backgroundColor: '#ba5fff', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>

                  <Box className={classes.featureCard} style={{ opacity: (!userDetails?.enable_audio_sts && !userDetails?.enable_audio_stt && !userDetails?.enable_audio_tts) && 0.5, border: `1px solid #ffba00` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={speechToSpeechHome} /> Audio Tools
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={(!userDetails?.enable_audio_sts && !userDetails?.enable_audio_stt && !userDetails?.enable_audio_tts)}
                        onClick={() => (userDetails?.enable_audio_sts || userDetails?.enable_audio_stt || userDetails?.enable_audio_tts) && history.push('/audio')}
                        style={{ backgroundColor: '#ffba00', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>

                  <Box className={classes.featureCard} style={{ opacity: !userDetails?.enable_image_generator && 0.5, border: `1px solid #7ebaff` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={aiImagesHome} /> AI Images
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={!userDetails?.enable_image_generator}
                        onClick={() => userDetails?.enable_image_generator && history.push('/images')}
                        style={{ backgroundColor: '#7ebaff', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>

                  <Box className={classes.featureCard} style={{ opacity: !userDetails?.enable_video_maker && 0.5, border: `1px solid #55d144` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={videoMakerHome} /> Video Maker
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={!userDetails?.enable_video_maker}
                        onClick={() => userDetails?.enable_video_maker && history.push('/video-maker')}
                        style={{ backgroundColor: '#55d144', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>

                  <Box className={classes.featureCard} style={{ opacity: !userDetails?.enable_translation && 0.5, border: `1px solid #5753D4` }}>
                    <Typography>
                      <img style={{ position: 'relative', top: '0.3rem', width: '1.3rem', marginRight: '0.2rem' }} src={liveTranslatorHome} /> Live Translation
                    </Typography>
                    <Box className={classes.featureActions}>
                      <Button
                        disabled={!userDetails?.enable_translation}
                        onClick={() => userDetails?.enable_translation && history.push('/live-translator')}
                        style={{ backgroundColor: '#5753D4', fontSize: '0.8rem', color: 'white' }}
                        variant='contained'
                      >
                        Vai alla funzionalità
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Box>

            <Box style={{ display: 'grid', gridTemplateColumns: '1fr', marginTop: '1rem' }}>
              <Box style={{ border: `1px solid ${customTheme.colors.ui.grey}`, padding: '1rem', borderRadius: 15 }}>
                <Box style={{ width: '100%' }}>
                  <Typography
                    component="h1"
                    variant="h6"
                    color="inherit"
                    noWrap
                    style={{ float: 'left', fontWeight: 'bold' }}
                  >
                    Archivio totale
                  </Typography>

                  <Typography
                    onClick={() => setTotalArchiveOpen(true)}
                    component="h1"
                    variant="h6"
                    color="inherit"
                    noWrap
                    style={{ cursor: 'pointer', textDecoration: 'underline', float: 'right', fontSize: '1rem', color: customTheme.colors.ui.grey }}
                  >
                    Vedi tutto l'archivio
                  </Typography>
                </Box>

                <Box style={{ display: 'grid', gridTemplateColumns: '1fr', width: '100%' }}>
                  <Box style={{ marginTop: '1rem', display: 'grid', gridTemplateColumns: '2fr', gap: 15, textAlign: 'left' }}>
                    <TableContainer>
                      <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Nome del file</TableCell>
                            <TableCell>Tipo file</TableCell>
                            <TableCell>Data</TableCell>
                            <TableCell>Dettagli condivisione</TableCell>
                            <TableCell></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {archive.length ? archive.slice(0, 3).map((file) => (
                            <TableRow
                              key={file.id}
                              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                              <TableCell component="th" scope="row">
                                {file?.filename}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {file.type}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                {moment(file.created_at).format('DD MMM YYYY - hh:mm')}
                              </TableCell>
                              <TableCell component="th" scope="row">
                                <Box><Box style={{ display: 'flex', flexDirection: 'row' }}>
                                  <Box style={{
                                    marginRight: '0.5rem',
                                    width: 22,
                                    height: 22,
                                    borderRadius: '50%',         
                                    display: 'inline-flex',       
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: userDetails?.email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39',
                                    color: 'white',
                                    lineHeight: 1,                
                                    textTransform: 'uppercase',  
                                    }}>{userDetails?.first_name.slice(0, 1)}
                                  </Box>
                                  {userDetails?.first_name} {userDetails?.last_name}
                                </Box></Box>
                              </TableCell>

                              <TableCell>
                                <img
                                  onClick={(event) => {
                                    setshowmenu(file.id)
                                    setAnchorEl(event.currentTarget)
                                  }}
                                  src={condividiSvg}
                                  style={{ marginRight: '0.5rem', cursor: 'pointer' }}
                                />
                                <DownloadIcon
                                  style={{ cursor: 'pointer' }}
                                  onClick={() => handleDownload(file.filename, file.file_url, file.content_type)}
                                />
                              </TableCell>

                              {showmenu === file.id && (
                                <Menu
                                  id="basic-menu"
                                  anchorEl={anchorEl}
                                  open={openMenuUser}
                                  onClose={handleClose}
                                  MenuListProps={{ 'aria-labelledby': 'basic-button' }}
                                >
                                  {users.map(({ id, first_name, last_name, email }) => {
                                    return (first_name || last_name) && (
                                      <MenuItem style={{ display: 'block' }} key={id}>
                                        <Box style={{
                                          float: 'left',
                                          marginRight: '0.5rem',
                                          borderRadius: 15, width: '24px', textAlign: 'center',
                                          height: '24px', background: email?.includes('bancasistema.it') ? '#B91F26' : '#D2AA39', color: 'white'
                                        }}>
                                          {first_name.slice(0, 1)}
                                        </Box>
                                        <Typography id="basic-menu" style={{ marginRight: '0.5rem', float: 'left' }}>
                                          {first_name} {last_name}
                                        </Typography>
                                        {loadingGrant.includes(email + file.url)
                                          ? <CircularProgress size={12} style={{ float: 'right' }} />
                                          : file?.grantees?.find((grant) => email === grant.email)
                                            ? <img src={deleteIcon} onClick={() => handleRemoveGrant(file.id, email, file.url)} style={{ cursor: 'pointer', color: customTheme.colors.ui.red, float: 'right' }} />
                                            : <AddIcon onClick={() => handleAddGrant(file.id, email, file.url)} style={{ cursor: 'pointer', color: customTheme.colors.ui.black, float: 'right' }} />
                                        }
                                      </MenuItem>
                                    )
                                  })}
                                </Menu>
                              )}
                            </TableRow>
                          )) : null}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        )}
      </main>
    </AppBar>
  )
}

export default Dashboard